import Vue from 'vue'
import router from './router'
import store from './js/store'

// import { BootstrapVue } from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import App from './js/views/App'
import { longClickDirective } from 'vue-long-click'
import Api from './js/plugins/api-plugin'
import AuthModal from './js/components/auth/AuthModal'
import ClickToUnlock from './js/components/form/ClickToUnlock'

Vue.use(VueAwesomeSwiper)
Vue.use(Api)

const longClickInstance = longClickDirective({delay: 100, interval: 50})
Vue.directive('longclick', longClickInstance)

const app = window.app = new Vue({
  el: '#vue-app',

  components: {
    App,
    AuthModal,
    ClickToUnlock,
  },

  router,

  store,
})

